import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import MessageList from '../components/Messages/MessageList';

const Messages = () => {
  return (
    <Routes>
      <Route path="/" element={<MessageList />} />
    </Routes>
  )
}

export default Messages;